import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import RightBanners from "../components/rightbanners";
import SeoHeaders from "../components/seoheaders";
class Loading extends Component {

  componentDidMount() {

  }

  render() {
    let showBan = this.props.WebPage.Settings.ShowRightBanners;
    return (
      <div className="content-wrap">
        <SeoHeaders Position={"Top"}/>
        <div className={`cell ${showBan ? "x9" : "x12"}`}>
          <div className="white-box advertise-content white-wrap the-content">
            <p style={{width: "100%", display: "flex", alignContent: "center", justifyContent: "center"}}>
              <img src="/imgs/loader.gif" width={"100px"} height={"100px"} alt={"Loading"}/>
            </p>
          </div>
          </div>
        {showBan &&
        <div className="cell x3">

        </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    MainContent: state.Website.Page.Content.Main,
    WebPage: state.Website,
  };
}

export default connect(mapStateToProps)(Loading);
